import { render } from "./MonitoraggioPuntualeForm.vue?vue&type=template&id=607dd061"
import script from "./MonitoraggioPuntualeForm.vue?vue&type=script&lang=js"
export * from "./MonitoraggioPuntualeForm.vue?vue&type=script&lang=js"

import "./MonitoraggioPuntualeForm.vue?vue&type=style&index=0&id=607dd061&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__